import React from 'react';
import { ArrowDown, ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';
import { WaitlistCTA } from '../WaitlistCTA';
export function SectionOne() {
  return <section className="relative flex min-h-screen flex-col justify-end supports-[height:100svh]:min-h-[100svh]" data-id="element-4976" data-mp="2rjk1af2mxqwv">
      <div className="relative flex flex-col gap-10 px-5 pb-16 sm:flex-row sm:items-end sm:justify-between sm:gap-8 sm:px-8 md:px-12 md:pb-20" data-id="element-4977" data-mp="2mkqq4tatmbzv">
        <h1 className="max-w-xl text-4xl font-title font-medium leading-[1.05] tracking-tight text-white drop-shadow-lg sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-4978" data-mp="1yvfsvlsoizqh">
          <Reveal as="span" delay={100} className="block pl-6 sm:pl-12" data-id="element-4979" data-mp="28l7tawngmn2v">
            Connect
          </Reveal>
          <Reveal as="span" delay={220} className="block pl-16 sm:pl-32" data-id="element-4980" data-mp="23tpnnvahrybk">
            <span className="italic font-light" data-id="element-4981" data-mp="1g455vfq2r73v">everything.</span>
          </Reveal>
        </h1>

        <div className="flex w-full max-w-xs flex-col items-start" data-id="element-4982" data-mp="1b5lidavu1n9e">
          <Reveal delay={520} className="w-full" data-id="element-4983" data-mp="1b37q19sjep5j">
            <p className="mb-6 text-sm leading-relaxed text-white/85 drop-shadow-md sm:mb-8" data-id="element-4984" data-mp="26o1oldf49z6y">
              Plug Giga into every tool, app, and data source you already use.
              It ties your whole stack together so context flows freely—no more
              copying, pasting, or switching tabs.
            </p>
          </Reveal>
          <Reveal delay={640} className="w-full" data-id="element-4985" data-mp="2kdvbvraz4bek">
            <WaitlistCTA to="/integrations" className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#EA580C] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-[#EA580C]/20 transition-all duration-300 hover:bg-[#d24e09] hover:scale-105" data-id="element-4986" data-mp="1noxfk4nks5fa">
              See all integrations
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-4987" data-mp="21ofa70njycwk" />
            </WaitlistCTA>
          </Reveal>
        </div>
      </div>

      <Reveal delay={760} className="absolute bottom-5 left-1/2 -translate-x-1/2 sm:bottom-6" data-id="element-4988" data-mp="3d329mo2lswyr">
        <ArrowDown size={18} className="animate-bounce text-white/80" data-id="element-4989" data-mp="1d0sz8zbrasfa" />
      </Reveal>
    </section>;
}